var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"slide_wrapper_item"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('v-slider',{staticClass:"slide_wrapper_item_cap",attrs:{"step":"1","tick-size":"1","min":"-1","max":"1","color":_vm.getColor(),"track-color":_vm.getColor()},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }